export const SNOWFLAKE_QUERY_PLAYGROUND_QUERIES = [
  {
    id: 'exp-snowflake-playground-smoke',
    label: 'Example — INFORMATION_SCHEMA connectivity',
  },
] as const;

export type SnowflakePlaygroundStageId =
  (typeof SNOWFLAKE_QUERY_PLAYGROUND_QUERIES)[number]['id'];
